export var MixinPrefs = {
  data: () => ({
    TO_PrefsObjectList: [],
    TT_PrefsKeyList: {},
    T_PrefsToken: "",
    B_PrefsLoaded: false,
    B_PrefsAccessDB: false
  }),
  created() {
    this.T_PrefsToken = "JWT " + this.$cookies.get("BackEndToken");
    this.Fct_PrefsLoad();
  },
  methods: {
    Fct_PrefsLoad() {
      this.$BackEndAPI
        .get("preferences/", { headers: { Authorization: this.T_PrefsToken } })
        .then(TO_Response => {
          if (TO_Response != null) {
            this.TO_PrefsObjectList = TO_Response.data;
            for (var L_Index = 0; L_Index < this.TO_PrefsObjectList.length; L_Index++) {
              var T_Key = this.TO_PrefsObjectList[L_Index].key;
              var T_Value = this.TO_PrefsObjectList[L_Index].value;
              if (T_Value == "") {
                T_Value = this.TO_PrefsObjectList[L_Index].file;
              }
              this.TT_PrefsKeyList[T_Key] = T_Value;
            }
            this.B_PrefsLoaded = true;
          }
        })
        .catch(O_Error => {
          this.$root.$children[0].IsisInfo("Could not retreive preferences data" + O_Error.message, "error");
        });
    },
    Fct_PrefsGetString(T_Key, T_Default = "") {
      var T_Value = this.TT_PrefsKeyList[T_Key];
      if (T_Value == "" || T_Value == undefined) {
        T_Value = T_Default;
      }
      return T_Value;
    },
    Fct_PrefsGetNum(T_Key, T_Default = "") {
      var T_Value = this.Fct_PrefsGetString(T_Key, T_Default);
      var R_Value = parseFloat(T_Value);
      return R_Value;
    },
    Fct_PrefsGetDate(T_Key, T_Default = "") {
      var D_Value = new Date(this.Fct_PrefsGetString(T_Key, T_Default));
      var T_Value = D_Value.getFullYear(D_Value) + "-" + D_Value.getMonth(D_Value) + "-" + D_Value.getDate(D_Value);
      return T_Value;
    },
    Fct_PrefsSetString(T_Key, T_Value) {
      this.B_PrefsAccessDB = true;

      // -- Add Local
      this.TT_PrefsKeyList[T_Key] = T_Value;
      for (var L_Index = 0; L_Index < this.TO_PrefsObjectList.length; L_Index++) {
        if (this.TO_PrefsObjectList[L_Index].key == T_Key) {
          this.TO_PrefsObjectList[L_Index].value = T_Value;
        }
      }

      // -- Add DB
      // Vérifier si la donnée existe bien dans la DB ->Update ou ->Insert
      this.$BackEndAPI
        .get("preferences/?key=" + T_Key, { headers: { Authorization: this.T_PrefsToken } })
        .then(TO_Response => {
          if (TO_Response != null) {
            var O_Data = TO_Response.data[0];
            if (O_Data != undefined) {
              var L_ID = parseInt(O_Data.id);
              this.Fct_PrefsModKey(L_ID, T_Value);
            } else {
              this.Fct_PrefsAddKey(T_Key, T_Value);
            }
          }
        })
        .catch(O_Error => {
          this.$root.$children[0].IsisInfo("Could not save preference data" + O_Error.message, "error");
        });
    },
    Fct_PrefsAddKey(T_Key, T_Value) {
      let O_FormData = new FormData();
      O_FormData.append("key", T_Key);
      O_FormData.append("value", T_Value);

      this.$BackEndAPI
        .post("preferences/", O_FormData, { headers: { Authorization: this.T_PrefsToken } })
        .then(TO_Response => {
          if (TO_Response != null) {
            this.B_PrefsAccessDB = false;
          }
        })
        .catch(O_Error => {
          this.$root.$children[0].IsisInfo("Could not add preference data" + O_Error.message, "error");
        });
    },
    Fct_PrefsModKey(L_ID, T_Value) {
      let O_FormData = new FormData();
      O_FormData.append("value", T_Value);

      this.$BackEndAPI
        .patch("preferences/" + L_ID + "/", O_FormData, { headers: { Authorization: this.T_PrefsToken } })
        .then(TO_Response => {
          if (TO_Response != null) {
            this.B_PrefsAccessDB = false;
          }
        })
        .catch(O_Error => {
          this.$root.$children[0].IsisInfo("Could not modify preference data" + O_Error.message, "error");
        });
    },
    Fct_PrefsGetID(T_Key) {
      var L_ID = 0;
      for (var L_Index = 0; L_Index < this.TO_PrefsObjectList.length; L_Index++) {
        if (this.TO_PrefsObjectList[L_Index].key == T_Key) {
          L_ID = this.TO_PrefsObjectList[L_Index].id;
        }
      }
      return L_ID;
    },
    Fct_PrefsGetFile(T_Key) {
      var T_File = "";
      for (var L_Index = 0; L_Index < this.TO_PrefsObjectList.length; L_Index++) {
        if (this.TO_PrefsObjectList[L_Index].key == T_Key) {
          T_File = this.TO_PrefsObjectList[L_Index].file;
        }
      }
      return T_File;
    },
    Fct_PrefsSetFile(T_Key, O_File) {
      this.B_PrefsAccessDB = true;

      // -- Add DB
      // Vérifier si la donnée existe bien dans la DB ->Update ou ->Insert
      this.$BackEndAPI
        .get("preferences/?key=" + T_Key, { headers: { Authorization: this.T_PrefsToken } })
        .then(TO_Response => {
          if (TO_Response != null) {
            var O_Data = TO_Response.data[0];
            if (O_Data != undefined) {
              var L_ID = parseInt(O_Data.id);
              this.Fct_PrefsModFile(L_ID, O_File);
            } else {
              this.Fct_PrefsAddFile(T_Key, O_File);
            }
          }
        })
        .catch(O_Error => {
          this.$root.$children[0].IsisInfo("Could not save preference data" + O_Error.message, "error");
        });
    },
    Fct_PrefsAddFile(T_Key, O_File) {
      let O_FormData = new FormData();
      O_FormData.append("key", T_Key);
      O_FormData.append("file", O_File);

      this.$BackEndAPI
        .post("preferences/", O_FormData, { headers: { Authorization: this.T_PrefsToken } })
        .then(TO_Response => {
          if (TO_Response != null) {
            this.B_PrefsAccessDB = false;
          }
        })
        .catch(O_Error => {
          this.$root.$children[0].IsisInfo("Could not add preference file" + O_Error.message, "error");
        });
    },
    Fct_PrefsModFile(L_ID, O_File) {
      let O_FormData = new FormData();
      O_FormData.append("file", O_File);

      this.$BackEndAPI
        .patch("preferences/" + L_ID + "/", O_FormData, { headers: { Authorization: this.T_PrefsToken } })
        .then(TO_Response => {
          if (TO_Response != null) {
            this.B_PrefsAccessDB = false;
          }
        })
        .catch(O_Error => {
          this.$root.$children[0].IsisInfo("Could not modify preference file" + O_Error.message, "error");
        });
    }
  }
};
